module.exports = __webpack_public_path__ + "img/2-6.18106e90.png";